export const environment = {
    production: false,
    identityUrl: 'https://identity-v2-dev.nside.io',
    withCredentials: true,
    angularAppUrl: 'https://tips-dash-v2-dev.nside.io',
    apiBaseUrl: 'https://tips-v2-dev.nside.io',
    assessApiBaseUrl: 'https://assess-api-dev.nside.io'
};
